import Stomp from "webstomp-client";

export default function install(Vue) {

    const stompProvider = (function () {

      const clientMap = {};


      function getClient(url){
        if(clientMap[url]){
          return clientMap[url];
        }else{
          let subscribeQueue=[];
          let isConnected=false;
          let client;
          try {
              client= Stomp.over(new WebSocket(url), {
              debug: false,
              protocols: Stomp.VERSIONS.supportedProtocols()
            });
          }catch(e){
            console.error(e);
            return;
          }

          function _subscribe(topic, onMessageCallBack,onSubscribeCallback) {
            if (isConnected) {
              let subscription = client.subscribe(topic, onMessageCallBack);
              if(typeof onSubscribeCallback==='function'){
                onSubscribeCallback(subscription);
              }
            }
            else subscribeQueue.unshift({topic, onMessageCallBack,onSubscribeCallback});
          }

          clientMap[url]={
            client,
            subscribe:_subscribe
          };


          client.connect(null, null, function () {
            isConnected = true;
            let s = subscribeQueue.pop();
            while (typeof s !== "undefined" && isConnected) {
              _subscribe(s.topic, s.onMessageCallBack,s.onSubscribeCallback);
              s = subscribeQueue.pop();
            }
          }, function () {
            isConnected = false;
          });

          return clientMap[url];
        }
      }

      window.addEventListener("beforeunload",()=>{
        Object.keys(clientMap).map(k=>clientMap[k]).forEach(socket=>{
          Object.keys(socket.client.subscriptions).forEach(key=>socket.client.unsubscribe(key));
          socket.client.disconnect();
        });
      });


        return {
            subscribe: (url,topic, onMessageCallBack,onSubscribeCallback) => {
              if(!url) console.error("url is not defined");
              if(!topic) console.error("topic is not defined");
              if(!onMessageCallBack) console.error("onMessageCallBack is not defined");
              if(!url || !topic || !onMessageCallBack) return;
              let client = getClient(url);
              if(client) {
                client.subscribe(topic, onMessageCallBack, onSubscribeCallback);
              }else console.error("can't get client");
            }
        }
    })();

    Vue.stomp = stompProvider;
    Object.defineProperty(Vue.prototype, '$stomp', {
        get() {
            return stompProvider
        },
    })
}
